import React, { useState, useEffect } from 'react';
import './Gallery.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";

function Gallery() {
  const [destinations, setDestinations] = useState([]);
  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    AOS.init();
    AOS.refresh();

    const fetchDestinations = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/destinations`);
        if (!response.ok) {
          throw new Error('Failed to fetch destinations');
        }
        const data = await response.json();

        const shuffledDestinations = data.sort(() => 0.5 - Math.random());
        const selectedDestinations = shuffledDestinations.slice(0, 5);

        setDestinations(selectedDestinations);
      } catch (error) {
        console.error('Error fetching destinations:', error);
      }
    };

    fetchDestinations();

    const interval = setInterval(() => {
      fetchDestinations();
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  const handleClick = (destination) => {
    setSearchParams({ id: destination.id });
    navigate(`/destination-info?id=${destination.id}`);
  };

  return (
    <div data-aos="zoom-in" className="gallery_container">
      <div className="gallery-title">
        <p className='title-primary'>Featured Destinations</p>
        <p className='title-secondary'>Beautiful Places Around The World</p>
      </div>

      <div className="img-dom">
        {destinations.slice(0, 1).map(destination => (
          <div className="lt_side" key={destination.destination_id}>
            <div className="img-container" onClick={() => handleClick(destination)}>
              <img 
                src={`${process.env.REACT_APP_BASE_URL}/${destination.image_preview}`} 
                alt={destination.destination_name} 
                className='img_gal_full' 
              />
              <div className="in-img">
                <p className='in-float-img'>{destination.destination_name}</p>
              </div>
            </div>
          </div>
        ))}

        <div className="rt_side">
          {destinations.slice(1).map(destination => (
            <div className="sm_img" key={destination.destination_id}>
              <div className="img-container" onClick={() => handleClick(destination)}>
                <img 
                  src={`${process.env.REACT_APP_BASE_URL}/${destination.image_preview}`} 
                  alt={destination.destination_name} 
                  className='img_gal' 
                />
                <div className="in-img">
                  <p className='in-float-img'>{destination.destination_name}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Gallery;